// extracted by mini-css-extract-plugin
export var active = "_de-7";
export var container = "_de-0";
export var evenWidth = "_de-4";
export var large = "_de-5";
export var outlet = "_de-8";
export var slide = "_de-2";
export var small = "_de-6";
export var tab = "_de-3";
export var tabs = "_de-1";